import React from 'react';
import { Logo } from './Logo';
import { ChevronLeftIcon } from 'lucide-react';
interface HeaderProps {
  caseName?: string;
  documentCount?: number;
  onLogout: () => void;
  onNavigateBack?: () => void;
}
export function Header({
  caseName,
  documentCount,
  onLogout,
  onNavigateBack
}: HeaderProps) {
  return <header className="h-16 border-b border-navy-light bg-navy px-6 flex items-center justify-between shrink-0" data-id="element-14">
      <div className="flex-1 flex items-center" data-id="element-15">
        {onNavigateBack ? <button onClick={onNavigateBack} className="flex items-center gap-1 group" data-id="element-16">
            <ChevronLeftIcon className="w-4 h-4 text-gray-500 group-hover:text-amber transition-colors" data-id="element-17" />
            <Logo size="md" data-id="element-18" />
          </button> : <Logo size="md" data-id="element-19" />}
      </div>

      {caseName && <div className="flex-1 flex justify-center items-center text-gray-300 text-sm font-medium" data-id="element-20">
          {caseName}
          {documentCount !== undefined && <span className="text-gray-500 ml-2 font-normal" data-id="element-21">
              — {documentCount.toLocaleString()} documents
            </span>}
        </div>}

      <div className="flex-1 flex justify-end" data-id="element-22">
        <button onClick={onLogout} className="text-sm text-gray-400 hover:text-white transition-colors" data-id="element-23">
          Logout
        </button>
      </div>
    </header>;
}